import { LinkButton } from "@/ui/next/LinkButton";
import { useTranslation } from "next-i18next";

import { getHelpArticlePath } from "@/common/utils/help/help-url.utils";

type HelpNeighbour = {
  slug: string;
  title: string;
  categorySlug: string;
};

type HelpArticleNeighboursProps = {
  previous?: HelpNeighbour | null;
  next?: HelpNeighbour | null;
};

export const HelpArticleNeighbours = ({
  previous,
  next,
}: HelpArticleNeighboursProps) => {
  const { t } = useTranslation("common");

  if (!previous && !next) {
    return null;
  }

  return (
    <div className="mt-10 flex flex-col gap-3 md:flex-row md:justify-between">
      {next ? (
        <LinkButton
          href={getHelpArticlePath(next.categorySlug, next.slug)}
          appearance="outlined"
          color="brand"
          size="medium"
          className="w-full md:order-2 md:w-auto"
        >
          {t("help-next-question", "Next question")}
        </LinkButton>
      ) : (
        <span className="hidden md:order-2 md:block" />
      )}
      {previous ? (
        <LinkButton
          href={getHelpArticlePath(previous.categorySlug, previous.slug)}
          appearance="outlined"
          color="brand"
          size="medium"
          className="w-full md:order-1 md:w-auto"
        >
          {t("help-previous-question", "Previous question")}
        </LinkButton>
      ) : (
        <span className="hidden md:order-1 md:block" />
      )}
    </div>
  );
};
